import { render } from "./Badge8.vue?vue&type=template&id=075dd03b"
import script from "./Badge8.vue?vue&type=script&lang=js"
export * from "./Badge8.vue?vue&type=script&lang=js"

import "./Badge8.vue?vue&type=style&index=0&id=075dd03b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__